// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/app/components/dialogs/components/Slate.module.css';
import {Button} from '@app/features/ui/button/Button';
import type {Icon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface SlateProps {
	icon: Icon;
	title: string;
	description: string;
	buttonText?: string;
	onClick?: () => void;
}
export const Slate: React.FC<SlateProps> = observer(({icon: Icon, title, description, buttonText, onClick}) => (
	<div className={styles.container}>
		<div className={styles.content}>
			<div className={styles.iconTextContainer}>
				<Icon className={styles.icon} />
				<div className={styles.textContainer}>
					<h3 className={styles.title}>{title}</h3>
					<p className={styles.description}>{description}</p>
				</div>
			</div>
			{buttonText && <Button onClick={onClick}>{buttonText}</Button>}
		</div>
	</div>
));
